import { X } from 'lucide-react';
import React from 'react';

interface DrawerProps {
  side?: 'left' | 'right' | 'bottom';
  isOpen: boolean;
  onClose: () => void;
  width?: string;
  height?: string;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  isShowCloseButton?: boolean;
}

const Drawer: React.FC<DrawerProps> = ({
  className,
  side = 'left',
  isOpen,
  onClose,
  width = '16rem',
  height = '90%',
  children,
  overlayClassName = 'fixed inset-0 bg-black bg-opacity-50',
  isShowCloseButton = false,
}) => {
  const isHorizontal = side === 'left' || side === 'right';

  const drawerStyle = {
    width: isHorizontal ? width : '100%',
    height: isHorizontal ? '100%' : height,
  };

  const positionClass = side === 'left' ? 'left-0 top-0' : side === 'right' ? 'right-0 top-0' : 'bottom-0 left-0';

  const transformDirection = side === 'left' ? '-translate-x-full' : side === 'right' ? 'translate-x-full' : 'translate-y-full';

  const openTransform = 'translate-x-0 translate-y-0';

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className={`${overlayClassName} z-40`} onClick={onClose} />}

      {/* Drawer */}
      <div
        className={`fixed ${positionClass} z-50 transform transition-transform duration-300 ease-in-out ${className}
          ${isOpen ? openTransform : transformDirection}`}
        style={drawerStyle}
      >
        {/* Close Button */}
        {isShowCloseButton && (
          <button
            className="absolute top-4 right-4 w-[24px] h-[24px] bg-black rounded-full flex justify-center items-center"
            onClick={onClose}
          >
            <X className="text-jen-grey-3" size={16} />
          </button>
        )}

        {/* Drawer Content */}
        <div className="h-full">{children}</div>
      </div>
    </>
  );
};

export default Drawer;
